import React from "react";

import homeImg from "../../assets/img/home.svg";

import Features from './../Features/Features';
import ScreenshotSlider from "../ScreenshotSlider/ScreenshotSlider";
// import Details from './../Details/Details';
import Testimonials from "../Testimonials/Testimonials";
// import Pricing from './../Pricing/Pricing';
import FAQ from "../FAQ/FAQ";
import Contact from './../Contact/Contact';

export default class Home extends React.Component {
    render() {
        return (
            <div>
                <div id="hero" className="d-flex align-items-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7 d-lg-flex flex-lg-column justify-content-center align-items-stretch pt-5 pt-lg-0 order-2 order-lg-1"
                                data-aos="fade-up">
                                <div>
                                    <h1>ExpenseGenie By Coderman401</h1>
                                    <h2>All in one place to track and manage all your expenses and incomes. </h2>
                                    <a href="https://play.google.com/store/apps/details?id=in.thecodercouple.expensegenie" target="blank" className="download-btn"><i className="bx bxl-play-store"></i> Google Play</a>
                                    {/*
                            <!-- <a href="!#" className="download-btn"><i className="bx bxl-apple"></i> App Store</a> -->
                            */}
                                </div>
                            </div>
                            <div className="col-lg-5 d-lg-flex flex-lg-column align-items-stretch order-1 order-lg-2 hero-img"
                                data-aos="fade-up">
                                <a href="https://storyset.com/business" target={'_blank'} rel="noreferrer">
                                    <img width="600" height="600" src={homeImg} className="img-fluid" alt="Home Page Banner" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <main id="main">
                    <section id="features" className="features">
                        <Features />
                    </section>

                    <section id="gallery" className="gallery">
                        <ScreenshotSlider />
                    </section>

                    <section id="testimonials" className="testimonials section-bg">
                        <Testimonials />
                    </section>

                    {/* <section id="pricing" className="pricing">
                        <Pricing />
                    </section> */}

                    <section id="faq" className="faq section-bg">
                        <FAQ />
                    </section>

                    <section id="contact" className="contact">
                        <Contact />
                    </section>
                </main>
            </div>
        );
    }
}
